import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenDeliveryAgentList from '../../../views/app/common/OpenDeliveryAgentList';
import { appActions } from '../../../store/modules/app';

class OpenDeliveryAgentListContainer extends Component {
  render() {
    return <OpenDeliveryAgentList {...this.props} />;
  }
}

const mapDispatchToProps = {
  getDeliveryAgentList: appActions.getDeliveryAgentList,
};

export default connect(null, mapDispatchToProps)(OpenDeliveryAgentListContainer);
